import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { stopImpersonating } from '../../utils/impersonation';
import './ImpersonationBar.css';

const fullName = (person) => `${person?.first_name || ''} ${person?.last_name || ''}`.trim() || person?.email || 'Unknown';

/**
 * The bar across the top of every page while an admin is navigating the site
 * as somebody else.
 *
 * It is the way back. The person being impersonated may have no access to the
 * admin pages - which is often the point - so the control that ends it cannot
 * live anywhere they would need permission to reach. It renders for as long as
 * the server says an impersonation is in effect, whatever the page.
 */
export default function ImpersonationBar() {
  const auth = useAuth();
  if (!auth.isImpersonating) return null;

  return (
    <div className="impersonation-bar" role="status">
      <i className="bi bi-person-badge impersonation-bar__icon" aria-hidden="true" />
      <div className="impersonation-bar__text">
        <span>
          Navigating as: <strong>{fullName(auth.employee)}</strong>
          {auth.employee?.email ? <span className="impersonation-bar__muted"> ({auth.employee.email})</span> : null}
        </span>
        <span className="impersonation-bar__muted">
          Signed in as {fullName(auth.impersonatedBy)}. You see their pages and have only their permissions,
          and anything you change is saved as them.
        </span>
      </div>
      <button
        type="button"
        className="impersonation-bar__stop"
        onClick={() => stopImpersonating()}
      >
        <i className="bi bi-box-arrow-left" aria-hidden="true" />
        Stop impersonating
      </button>
    </div>
  );
}
